import React, { useRef } from "react";
import "./Card.css";
import img from "../Assets/IMG20210404105035.jpg";
import img_1 from "../Assets/shopperstop.png";
import img_3 from "../Assets/Business.png";
import img_4 from "../Assets/Learn_Prep.png";
import img_5 from "../Assets/Weather.png";
import img_7 from "../Assets/Pokemon.png";
import img_9 from "../Assets/Portfolio.png";
import img_11 from "../Assets/Screenshot 2025-04-01 171503.png";
import { lazy } from "react";
import { Fade } from "react-awesome-reveal";
import { customAnimation } from "../App.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaGithub } from "react-icons/fa";
export const ProjectCards1 = lazy(() => import("./ProjectCards.js"));

export default function ProjectCards() {
  const cardRef = useRef(null);
  const imgRef = useRef(null);
  const titleRef = useRef(null);

  const sizesboxRef = useRef(null);
  const purchaseRef = useRef(null);
  const all_p = [
    {
      img: img_9,
      title: "This Portfolio",
      tech: "React.js , Bootstrap , CSS , HTML , Javascript",
      discription: "Portfolio Website (Responsive)",
    },
    {
      img: img_11,
      title: "Lets Connect",
      tech: "Next.JS , WeBRTC , WebSockects , NodeJS , ExpressJS , WebWorkers , Postgress SQL",
      Codebase: {
        required: true,
        link: "https://github.com/theavitw/Let-s_Connect",
      },
      Deployed: {
        required: true,
        link: "https://lets-connect-avits-project.vercel.app/",
      },
      discription:
        "real-time video calling app with an interactive UI for toggling audio/video and managing connections",
    },
    {
      img: img_1,
      title: "ShopperStop",
      tech: "React.js , MUI , CSS , Cart Management, User Authentication , Postgress , Filtering",
      Codebase: {
        required: true,
        link: "https://github.com/theavitw/ShoppersStop",
      },
      discription:
        "Dive into a seamless shopping experience with cutting-edge features and a sleek UI/UX design. This represents mt proefficiency in react and creating software applications.",
      Deployed: {
        required: true,
        link: "https://shoppersstopsite.netlify.app/",
      },
    },

    {
      img: img_4,
      title: "Learning Application",
      tech: "React.js , Bootstrap , Node.js , Express.js , MongoDB",
      discription: "Go to Website For Frontend Preview.",
      Codebase: {
        required: true,
        link: "https://github.com/theavitw/Learning_Platform",
      },
    },

    {
      img: img_3,
      title: "Business Website",
      Codebase: {
        required: true,
        link: "https://github.com/theavitw/Business.github.io",
      },
      Deployed: {
        required: true,
        link: "https://theavitw.github.io/Business.github.io/",
      },
      discription: "Business Website (Responsive)",
      tech: "React.js , Bootstrap , CSS , HTML , Javascript , Node.js , Express.js",
    },
    {
      img: img,
      title: "Text Editor",
      Codebase: {
        required: true,
        link: "https://github.com/theavitw/Text-Editor",
      },
      discription: "Python Text Editor inspired by Notepad",
      tech: "Python , Tkinter , Spyder",
    },
    {
      img: img,
      title: "Chat GPT Clone",
      Codebase: {
        required: true,
        link: "https://github.com/theavitw/ChatGpt-Avit-s-version",
      },
      discription: " Chat Application using OpenAI GPT-3 API (Responsive)",
      tech: "React.js , Bootstrap , React-Chat-Engine , Rest API , OpenAI GPT-3",
    },
    {
      img: img_7,
      title: "Pokemon_search",
      tech: "React.js , PokeAPI",
      Codebase: {
        required: true,
        link: "https://github.com/theavitw/PokemonnInfo",
      },
      Deployed: {
        required: true,
        link: "https://pokemonn-info.netlify.app/",
      },
      discription:
        "Change background colors, added state preservation, and integrate Pokemon-API for displaying Pokemon info in a visually attractive design.Seamlessly sort and search for Pokemon with their name, generation, and version on any device",
    },
    {
      img: img_5,
      title: "Weather App",
      Codebase: {
        required: true,
        link: "https://aweathi.netlify.app/",
      },
      Deployed: {
        required: true,
        link: "https://theavitw.github.io/Whether-App/",
      },
      discription:
        "Using Ninga API to get the weather data of the city entered by the user and displaying it on the screen.",
      tech: "HTML,CSS,Bootstrap,Fetch API,JavaScript",
    },

    {
      img: img,
      title: "More Projects",
      tech: "Python , Machine Learning , Jupyter Notebook , PHP",
      discription: "Visit My Github Profile For More Projects",
      Github: { required: true, link: "https://github.com/theavitw" },
    },
  ];
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // Set autoplay speed in milliseconds (e.g., 3000ms = 3 seconds)
  };
  return (
    <Fade direction="left" keyframes={customAnimation} triggerOnce>
      <div className="main">
        <h1 className="head">My Projects</h1>
        <div className="container1">
          <Slider {...settings}>
            {all_p.map((p, i) => {
              return (
                <div className="card" ref={cardRef}>
                  <img
                    ref={imgRef}
                    src={p.img}
                    alt="Nike-Shoe"
                    className="card-img-top"
                  />
                  <h2 className="title" ref={titleRef}>
                    {p.title}
                  </h2>
                  <p className="text-white text-center mb-3" ref={titleRef}>
                    {p.discription}
                  </p>

                  <ul className="sizes-box" ref={sizesboxRef} key={i}>
                    {p.tech.split(",").map((t) => {
                      return <span>{t}</span>;
                    })}
                  </ul>

                  <div className="button-box d-flex gap-2" ref={purchaseRef}>
                    {p.Codebase ? (
                      <a href={p.Codebase.link} target="_blank" rel="noreferrer">
                        <button className="btn btn-danger">Codebase</button>
                        <FaGithub/>
                      </a>
                    ) : (
                      <></>
                    )}
                    {p.Deployed ? (
                      <a
                        href={p.Deployed.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button className="btn btn-danger">Live</button>
                      </a>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </Fade>
  );
}

